export default __webpack_public_path__ + "static/media/gamma-sync.b8f35916.svg";